module.exports = __webpack_public_path__ + "static/media/YB5M04_3.9e5b3eaf.jpg";